<template>
  <b-row :class="{'almost-empty': vmVariant.inventoryQuantity < 10}">
    <b-col sm="6">
      <label>{{ variant.title }} <br><small>{{localizedCurrency(variant.price, currency) }} {{ !variant.title.includes('reserv') ? ' - für alle' : '' }}</small></label>
    </b-col>
    <b-col sm="4">
      <b-input-group size="sm" append="Einheiten">
        <b-form-input v-model="vmVariant.inventoryQuantity" :state="isValid ? null : false" style="min-width: 30px" type="number" min="0" step="1" size="sm"></b-form-input>
      </b-input-group>
      <b-form-invalid-feedback :state="isValid ? null : false">{{ invalidMessage }}</b-form-invalid-feedback>
    </b-col>
    <b-col sm="2">
      <label><b-button class="btn-sm" :variant="changed && isValid ? 'primary' : 'secondary'" @click="$emit('save-inventory', vmVariant)" :disabled="!changed || !isValid"><i class="fas fa-save"></i></b-button></label>
    </b-col>
  </b-row>
</template>

<script>
import {INVALID_QUANTITY_MESSAGE, parseQuantity} from "@/utils/inventory";

export default {
  props: ['variant', 'currency'],
  data() {
    return {
      vmVariant: {},
      invalidMessage: INVALID_QUANTITY_MESSAGE
    }
  },
  created() {
    this.vmVariant = {...this.variant}
  },
  computed: {
    changed() {
      return this.vmVariant.inventoryQuantity.toString() !== this.variant.inventoryQuantity.toString()
    },
    isValid() {
      return parseQuantity(this.vmVariant.inventoryQuantity) !== null
    },
  }
}
</script>
